import React, { useCallback, useState } from "react";
import { Box, GridItem } from "@chakra-ui/react";
import { PhotosIcon } from "../../../Components/Icons/photos";
import PageLoader from "../../../Components/Common/PageLoader";
import { useNavigate } from "react-router-dom";

export const PhotoBookImage = ({ currentvalue }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [ImageLoading, setImageLoading] = useState(false);
  const navigate = useNavigate();
  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);
  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  const images = [currentvalue.images[0]?.mediaUrl];
  return (
    <>
      <GridItem marginBottom={"4"} key={Math.random()}>
        <Box>
          <Box margin={"2px"} position={"relative"} cursor={"pointer"}>
            <Box
              zIndex={12}
              position={"absolute"}
              bottom={4}
              left={5}
              borderRadius={"64px"}
            >
              <Box
                display={"flex"}
                backgroundColor={"rgba(13, 13, 13, 0.8)"}
                padding={"1"}
                onClick={() => {
                  navigate(`/albumImages/${currentvalue._id}`);
                }}
              >
                <PhotosIcon width="20px" height="20px" />{" "}
                <Box marginLeft={"2"} color={"white"}>
                  {currentvalue?.count} Images
                </Box>
              </Box>
            </Box>
            <Box marginLeft={"4"}>{currentvalue.photoBookName}</Box>
            <PageLoader isLoading={ImageLoading} spinnerColor={null}>
              {images.map((src, index) => {
                return (
                  <Box>
                    <img
                      src={src}
                      style={{
                        height: "225px",
                        width: "450px",
                        borderRadius: "20px",
                      }}
                      effect="blur"
                      onClick={() => {
                        navigate(`/photobookImages/${currentvalue._id}`);
                      }}
                    />
                  </Box>
                );
              })}
            </PageLoader>
          </Box>
        </Box>
      </GridItem>
    </>
  );
};
